import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DossierFlowService } from 'app/shared/service/dossier-flow.service';
import { disableF5 } from 'app/shared/util/modal.util';
/**
 * Angular Component that show the expiration days remains for the pec user and invite user to
 */
@Component({
  selector: 'ap-pec-conversion-docaposte-adv',
  templateUrl: './pec-conversion-docaposte-adv.modal.component.html',
})
export class PecConversionDocaposteAdvisorModalComponent implements OnInit {
  @Input()
  public recognitionStatus = '';

  @Input()
  public twoFaEnabled = false;

  @Input()
  public urlWebmail = '';

  @Input()
  public urlPGA = '';

  @Input()
  public salesChannel = '';

  @Input()
  public mailbox = '';

  @Input()
  public urlLogo = '';

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly dossierFlowService: DossierFlowService
  ) { }

  /**
   * Add event listeners to keyboard event in order to prevent default behavior for F5 key
   */
  ngOnInit(): void {
    window.addEventListener('keyup', disableF5);
    window.addEventListener('keydown', disableF5);
  }

  /**
   * Redirect to ids if dossier service quesry is success,
   * otherwise display error based on the error status and sales channel
   */
  goToIds(): void {
    this.dossierFlowService.executeDossierFlow({
      mailbox: this.mailbox,
      urlPGA: this.urlPGA,
      urlWebmail: this.urlWebmail,
      salesChannel: this.salesChannel
    });
  }

  /**
   * Close modal
   */
  hideAdvise(): void {
    window.removeEventListener('keyup', disableF5);
    window.removeEventListener('keydown', disableF5);
    this.activeModal.close();
  }
}
